import { POST } from "@/utils/axios";

export function getVideoGroupList(data){
    return POST('/video/getVideoGroupList', data)
}

export function getVideoGroupInfo(data){
    return POST('/video/getVideoGroupInfo', data)
}

export function getVideoSTS(data){
    return POST('/video/generatePlayUrl', data)
}

export function getVideoBannerList(data){
    return POST('/common/getVideoBannerList', data)
}

export const apiCreateOrder = (data) => POST('/video/createSingleVideoOrder', data)